var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticStyle: { display: "flex", "flex-direction": "column" } },
        [
          _c(
            "el-col",
            { staticStyle: { margin: "15px" }, attrs: { span: 6 } },
            [
              _c("app-label", { attrs: { label: "N° SEI: ", required: true } }),
              _c(
                "el-input",
                {
                  staticClass: "input",
                  class: {
                    erro: !_vm.model.numerosSei.length && _vm.errorView
                  },
                  attrs: { name: "N° SEI" },
                  model: {
                    value: _vm.numeroSei,
                    callback: function($$v) {
                      _vm.numeroSei = $$v
                    },
                    expression: "numeroSei"
                  }
                },
                [
                  _c("el-button", {
                    staticStyle: { color: "#009f61" },
                    attrs: { slot: "append", icon: "el-icon-plus" },
                    on: {
                      click: function($event) {
                        return _vm.addNumeroSei()
                      }
                    },
                    slot: "append"
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "10px" } },
                _vm._l(_vm.model.numerosSei, function(numeroSei, index) {
                  return _c(
                    "el-tag",
                    {
                      key: index,
                      staticStyle: { margin: "5px" },
                      attrs: {
                        closable: "closable",
                        type: "info",
                        size: "medium"
                      },
                      on: {
                        close: function($event) {
                          return _vm.removeNumeroSei(index)
                        }
                      }
                    },
                    [_vm._v(_vm._s(numeroSei))]
                  )
                }),
                1
              ),
              !_vm.model.numerosSei.length && _vm.errorView
                ? _c("span", { attrs: { id: "erro" } }, [
                    _vm._v("Adicione no mínimo um N° SEI")
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { ref: "extratoSentenca", staticClass: "container" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.model,
                    "label-position": "top",
                    "label-width": "12em"
                  }
                },
                [
                  _c("vue-form-generator", {
                    ref: "form",
                    attrs: {
                      schema: _vm.schema,
                      model: _vm.model,
                      options: _vm.formOptions
                    },
                    on: { "model-updated": _vm.onModelUpdated }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { margin: "15px" }, attrs: { span: 6 } },
            [
              _c("app-label", {
                attrs: { label: "Limites: ", required: true }
              }),
              _c(
                "el-input",
                {
                  staticClass: "input",
                  class: { erro: !_vm.model.limites.length && _vm.errorView },
                  attrs: { name: "Limites" },
                  model: {
                    value: _vm.limite,
                    callback: function($$v) {
                      _vm.limite = $$v
                    },
                    expression: "limite"
                  }
                },
                [
                  _c("el-button", {
                    staticStyle: { color: "#009f61" },
                    attrs: { slot: "append", icon: "el-icon-plus" },
                    on: {
                      click: function($event) {
                        return _vm.addLimite()
                      }
                    },
                    slot: "append"
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "10px" } },
                _vm._l(_vm.model.limites, function(limite, index) {
                  return _c(
                    "el-tag",
                    {
                      key: index,
                      staticStyle: { margin: "5px" },
                      attrs: {
                        closable: "closable",
                        type: "info",
                        size: "medium"
                      },
                      on: {
                        close: function($event) {
                          return _vm.removeLimite(index)
                        }
                      }
                    },
                    [_vm._v(_vm._s(limite))]
                  )
                }),
                1
              ),
              !_vm.model.limites.length && _vm.errorView
                ? _c("span", { attrs: { id: "erro" } }, [
                    _vm._v("Adicione no mínimo um limite")
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0088a320", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0088a320","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppEmissaoExtratoSentenca.vue
// module id = null
// module chunks = 